module.exports = __webpack_public_path__ + "static/img/bg-hetebao.e707490.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-hetebao.png
// module id = hJay
// module chunks = 0